/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Observable } from "@vienna-hypertext/observable";

import { Point } from "src/classes/plate/lib/types";
import { SessionSnapshot } from "src/classes/plate/Session";

export abstract class BaseSession<T extends SessionSnapshot> extends Observable<T> {
  constructor(snapshot: T) {
    super(snapshot);
  }

  public abstract start(): void;
  public abstract end(): void;
  public abstract cancel(): void;
}

export interface ClickSession {
  anchor: Point;
  hasMadeSelection: boolean;
}
